<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="[
            'baodanData.startdata',
            { rules: [{ required: true, message: '请选择起始日期！' }] },
          ]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled
          placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" v-decorator="[
            'applicantInfo.name',
            { rules: [{ required: true, message: '请输入投保企业名称' }] },
          ]" @blur="
          (e) => checkLength(e.target.value, 'applicantInfo.name')
        " placeholder="请输入投保企业名称"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select :disabled="disabledAll" @change="(value) => handleChange(value, 'idType')" v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [
                    { required: true, message: '请选择投保企业证件类型' },
                  ],
                },
              ]" placeholder="请选择投保企业证件类型">
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
            <a-input v-model="applicantInfo.idNumber" :disabled="disabledAll" v-decorator="[
                'applicantInfo.idNumber',
                {
                  rules: [
                    { required: true, message: '请输入投保企业证件号码' },
                  ],
                },
              ]" placeholder="请输入投保企业证件号码"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="行业类别">
            <a-select placeholder="请选择行业" :disabled="disabledAll"
              :showSearch="true"
              :filter-option="filterOption"
              @change="(value,option ) => handleChange(value, 'industrycode',option)" v-decorator="[
              'applicantInfo.industrycode',
              { rules: [{ required: true, message: '请选择行业' }] },
            ]">
              <a-select-option v-for="item in industryList" :key="item.key" :value="item.value">{{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader placeholder="请选择" :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)" v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]" :options="addressOptions" :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" style="float: left; width: 250px" />
          </a-col>
          <a-col :span="12">
            <a-input v-model="applicantInfo.detailaddress"
              @blur="(e) => checkLength(e.target.value, 'applicantInfo.detailaddress')" :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.detailaddress',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]" placeholder="请输入联系地址" style="float: left; width: 350px; margin-left: 10px"></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input v-model="applicantInfo.contactsname" :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]" placeholder="请输入联系人姓名"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input v-model="applicantInfo.contactsphone" :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [{ required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }],
                },
              ]" placeholder="请输入联系人电话"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input v-model="applicantInfo.email" :disabled="disabledAll" v-decorator="[
                'applicantInfo.email',
                {
                  rules: [{ required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }],
                },
              ]" placeholder="请输入联系人邮箱"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- <a-row :gutter="24">
        <a-form-item :label-col="{ span: 3 }" label="保单备注" style="padding: 0 12px">
          <a-input :disabled="disabledAll" style="width: 100%" v-model="applicantInfo.remark"
            v-decorator="['applicantInfo.remark']" placeholder="请输入保单备注"></a-input>
        </a-form-item>
      </a-row> -->
      <salInsuredList :disabledAll="disabledAll" :columns="columns" :salInsuredList="salInsuredList"
        @delSelect="delSelectpre" @calTotalPremium='calTotalPremium' @addSelect="addSelectpre"
        @EduitSelect="EduitSelect"></salInsuredList>

      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-row :span="12">
          <a-col :span="8">
            <a-form-item label="保费" :label-col="{ span: 3 }">
              <a-input v-model="applicantInfo.totalPremium" disabled addonAfter="元" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="加费系数">
              <a-input-number style="width: 100%;" :parser="limitDecimalsP" :disabled="disabledAll" v-decorator="[
              'premiumCalType',
              {
                initialValue: '0',
                rules: [
                  {
                    message: '请输入',
                    required: false,
                  },
                ],
              },
            ]" :min="0" @blur="addPremiumBlur" />
            </a-form-item>
            <p style="font-style:normal;color: red;font-size:12px;">最多支持两位小数</p>

          </a-col>
          <a-col :span="8">
            <a-form-item label="加费后总保费" :label-col="{ span: 8 }">
              <a-input disabled addonAfter="元" v-decorator="[
              'addTotalPrices',
              {
                rules: [
                  {
                    message: '请输入',
                    required: false,
                  },
                ],
              },
            ]" />
            </a-form-item>
            <p style="font-style:normal;color: red;font-size:12px;">加费后总保费=（1+加费系数）*原始保费</p>
          </a-col>
        </a-row>
        <a-col :span="16">
          <a-form-item :label-col="{ span: 3 }" label="支付方式">
            <a-select @change="(value) => handleChange(value, 'payMethod')"
              style="width: 230px" placeholder="请选择支付类型" :disabled="disabledAll" v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }],
                },
              ]">
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled='!agreementAllRead' @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意<fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll"
              @click="handleSubmit">
              保存订单
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll"
              @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">
              编辑
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定"
      cancelText="关闭">
      <p style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        ">
        您投保的{{ productName() }}需支付保费
        <span style="color: #fe8f2d; font-weight: bold">{{
          addTotalPrices
        }}</span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  // import Vue from 'vue'
  import moment from "moment";
  import salInsuredList from "./salInsuredList";
  import { policyMixin } from '@/mixins/policyMixin.js';
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: { salInsuredList },
    mixins: [policyMixin],
    data() {
      //这里存放数据
      return {
        submitLoad1: false, //保存中
        yueduBtn: false,//阅读中
        // submitLoad2: false, //提交中
        showPaySure: false, //支付
        postPolicyData: {}, //要提交的数据
        policyId: "", //支付回来的id
        checkVisible: false, //凭证支付
        showQrcodePayModal: false, // 二维码支付
        addTotalPrices: 0,
        /**需要的数据开始 */
        applicantInfo: {
          name: "", //投保企业名称
          idType: "", //证件类型
          idNumber: "", //证件号码
          pacCode: "", //省市区
          address: "", //省市区中文
          detailaddress: "", //详细地址
          industrycode: "", //行业类别
          contactsname: "", //联系人名称
          contactsphone: "", //联系人电话
          email: "", // 邮箱
          vehicleown: "", // 投保人行业名称
          engineno: "", // 企业性质名称
          remark: 1, //保单备注
          payMethod: "", //支付类型
          totalPremium: 0, //总保费
          expireDate: "", //保单终止时间
          effectiveDate: "", // 保单生效时间
          mon: 12, //保证期限
        },
        //表格的头部
        columns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            scopedSlots: { customRender: "index" },
          },
          {
            title: "计划名称",
            dataIndex: "workUnit",
          },
          {
            title: "姓名",
            dataIndex: "name",
          },
          {
            title: "证件类型",
            dataIndex: "idType",
            key: "idType",
            scopedSlots: { customRender: "idType" },
          },
          {
            title: "证件号码",
            dataIndex: "idNumber",
          },
          {
            title: "出生日期",
            dataIndex: "birthDate",
          },
          {
            title: "性别",
            dataIndex: "gender",
            key: "gender",
            scopedSlots: { customRender: "gender" },
          },
          {
            title: "职业代码",
            dataIndex: "occupationCode",
          },
          {
            title: "职业名称",
            dataIndex: "occupationName",
          },
          {
            title: "职业类别",
            dataIndex: "occulevel",
            key: "occulevel",
            scopedSlots: { customRender: "occulevel" },
          },
          {
            title: "保费",
            dataIndex: "premium",
          },
        ],
        salInsuredList: [],//表格的数据
        rate: 0.2, //费率
        industrycodeTEXT: "", //四级行业的文本
        mobilestringcode: "0;0;0;0;0", //每一类添加的保费
        maxType: 1, //最大类别
        companyCode: "01", //企业性质
        perRiskInfo: "", //险种类
        evidenceNumber: "", //凭证号
        riskNumber: {}, //计算保费
        uniqueArr: [], //去重后的人数列表
        //投保人证件类型
        companyIdTypeOptions: [
          {
            value: "1",
            name: "组织机构代码证",
          },
          {
            value: "4",
            name: "营业执照",
          },
        ],
        //投保的天数
        guarantPre: [
          {
            key: 1,
            value: "1个月",
          },
          {
            key: 3,
            value: "3个月",
          },
          {
            key: 6,
            value: "6个月",
          },
          {
            key: 12,
            value: "12个月",
          },
        ],
        loading: false,
        form: this.$form.createForm(this, { name: "advanced_search" }),
        RiskInfos: {
          salPolicy: {
            productCode: "", //产品code
            planCode: "",
            groupSize: 0, //人数
            creator: "", //用户id
            bracket: 12, //保费期限
            totalPremium: 0, //总保费
            coverageamount: 0, //总保额
          },
          salPolicyExt: {
            isworkheightinvolved: 2,
            occEmpVersion: 0,
            occuRiskPremium: null,
          },
          salPolicyHolder: {
            addfifty: "2", // 测算类型
            name: "", //被保人名称
            stature: 2, //是否高空（2-否，1-是）
            vehicleown: "", // 投保人行业名称
            engineno: "", // 企业性质名称
          },
        }, //测算的数据
        modalVisible: false, //修改保费的弹窗
        CScontent: {},
        ContentView: {}, //展示的保费
        copyCScontent: {}, //拷贝的
        creator: "1",
        productCode: "",
        plan: "",
        userParams: "",
        /**需要的数据结束 */
        guapre: 1,
        planOffsetDay: 0,
        baodanData: {
          startdata: "",
        },
        startValues: null,
        linshiContent: {},
        riskInfosAmount: {}, //计算险种的结果
        ZBAOFEI: 0, //原始保费
        addBAOFEI: 0, //修改添加的保费
        orderContent: {}, //订单的数据
        disabledAll: false, //是否是立即投保
        gztypestr: "",
        planList: [],//计划列表
        industryList: require('../js/industryList.json'),//行业code
      };
    },
    //监听属性 类似于data概念
    computed: {
      addressOptions() {
        let twoArrCode = "110000,310000,440000,320000"
        let dataArr = window.addrescode.filter(item => twoArrCode.indexOf(item.value) > -1)
        return dataArr
      },
      applicantInfoExpireDate() {
        var mon = this.applicantInfo.mon;
        var date = this.applicantInfo.effectiveDate;
        if (date != "") {
          return moment(date).add(mon, 'M').subtract(1, 's');
        }else{
          return ''
        }
      },
    },
    //方法集合
    methods: {
      moment,
      productName() {
        return sessionStorage.getItem('productName')
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      gonOne() {
        this.disabledAll = false;
        this.addBAOFEI = this.$accuracy.sub(
          this.applicantInfo.totalPremium,
          this.ZBAOFEI
        );
        this.$bus.$emit("disabledBus", false);
        this.$router.push({
          name: "fxty",
          query: {
            u: this.$route.query.u,
            p: this.$route.query.p,
            sign: this.$route.query.sign,
          },
        });
      },
      queryOrderDetails() {
        // 查询保单信息
        let parms = {
          policyId: this.$route.query.policyId,
        };
        this.$api
          .queryOrderDetails(parms)
          .then((res) => {
            if (res.data.returnCode == 0) {
              if (res.data.content) {
                this.orderContent = res.data.content;
                this.$store.commit("setOrderContent", this.orderContent);
                var riskInfos
                if (res.data.content.riskInfos) {//险种信息
                  riskInfos = res.data.content.riskInfos;
                }
                if (res.data.content.salInsuredList) {
                  //被保人清单
                  this.salInsuredList = res.data.content.salInsuredList;
                  this.salInsuredList.forEach((element, i) => {
                    let str = element.birthDate;
                    let birthDate = [
                      str.substring(0, 4),
                      str.substring(4, 6),
                      str.substring(6, 8),
                    ]; //职业类别代码
                    element["index"] = i;
                    element.occulevel = element.occulevel == 'S' ? '特殊职业' : parseInt(element.occulevel)
                    element.birthDate = birthDate.join("-"); //生日
                  });
                }
                if (res.data.content.salPolicy) {
                  let salPolicy = res.data.content.salPolicy;
                  this.RiskInfos.salPolicy.coverageamount =
                    salPolicy.coverageamount;
                  this.policyId = salPolicy.id.toString();
                  this.plan = salPolicy.planCode;
                  this.applicantInfo.mon = parseInt(salPolicy.bracket);
                  this.applicantInfo.totalPremium = salPolicy.transactionTotalPremium;
                  this.applicantInfo.payMethod = salPolicy.payMethod
                  this.creator = salPolicy.creator;
                  this.productCode = salPolicy.productCode;
                  this.$store.commit("setproductCode", this.productCode);
                  this.applicantInfo.effectiveDate = moment(
                    salPolicy.effectiveDate
                  ).format("YYYY-MM-DD HH:mm:ss");
                  this.baodanData.startdata = this.applicantInfo.effectiveDate;
                  this.form.setFieldsValue({
                    premiumCalType: salPolicy.discountfactor,
                    applicantInfo: {
                      ...salPolicy,
                      effectiveDate: moment(salPolicy.effectiveDate).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                    },
                    baodanData: {
                      startdata: moment(salPolicy.effectiveDate).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                    },
                  });
                }
                if (res.data.content.salPolicyHolder) {
                  let salPolicyHolder = res.data.content.salPolicyHolder;
                  if (salPolicyHolder.planinfos) {
                    let planinfos = JSON.parse(salPolicyHolder.planinfos)
                    this.$bus.$emit("busPlaninfos", planinfos, riskInfos);
                  }
                  this.applicantInfo.name = salPolicyHolder.name;
                  this.mobilestringcode = salPolicyHolder.mobilestringcode;
                  this.applicantInfo.industrycode = salPolicyHolder.industrycode
                  this.applicantInfo.detailaddress = salPolicyHolder.detailaddress;
                  this.applicantInfo.vehicleown = salPolicyHolder.vehicleown;
                  this.applicantInfo.engineno = salPolicyHolder.engineno;
                  this.applicantInfo.address = salPolicyHolder.address;
                  this.gztypestr = res.data.content.salPolicyHolder.gztypestr;
                  this.copyCScontent = this.Filtergztypestr(this.gztypestr);
                  this.form.setFieldsValue({
                    applicantInfo: {
                      ...salPolicyHolder,
                      pacCode:
                        [
                          salPolicyHolder.province,
                          salPolicyHolder.city,
                          salPolicyHolder.district,
                        ] || [],
                      industrycode: salPolicyHolder.industrycode,
                      idType: salPolicyHolder.idType,
                    },
                  });
                }
                if (res.data.content.salPolicyExt) {
                  this.RiskInfos.salPolicyExt.occuRiskPremium =
                    res.data.content.salPolicyExt.occuRiskPremium;
                  this.RiskInfos.salPolicyExt.isworkheightinvolved = res.data
                    .content.salPolicyExt.isworkheightinvolved
                    ? res.data.content.salPolicyExt.isworkheightinvolved
                    : "2";
                  this.RiskInfos.salPolicyExt.occEmpVersion =
                    res.data.content.salPolicyExt.occEmpVersion;
                  this.$bus.$emit("salPolicyExt", res.data.content.salPolicyExt);
                }
                // debugger
                this.salInsuredList = res.data.content.salInsuredList;
                this.RiskInfos.salPolicy = {
                  ...this.RiskInfos.salPolicy,
                  ...res.data.content.salPolicy
                };
                this.RiskInfos.salPolicyHolder = {
                  ...this.RiskInfos.salPolicyHolder,
                  ...res.data.content.salPolicyHolder
                };
              }
            }
          })
      },
      Filtergztypestr(data) {
        let newData = data.split(";").slice(8, -1);
        let obj = {};
        newData.forEach((e, i) => {
          obj[i + 1] = e;
        });
        return obj;
      },
      //处理险种的拼接字段
      perRiskInfoNew(perRiskInfo) {
        var arrperRiskInfo = [];
        perRiskInfo.forEach((e) => {
          if (e.riskCode == "GSSGCJ" && e.amount > 0) {
            arrperRiskInfo.push(
              "10-工伤身故、残疾-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "GSSGYL" && e.amount > 0) {
            arrperRiskInfo.push(
              "11-工伤事故医疗费用-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "TZSBFWW" && e.amount > 0) {
            arrperRiskInfo.push(
              "55-扩展社保范围外医疗费用-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "24HYWXTB" && e.amount > 0) {
            arrperRiskInfo.push(
              "44-24小时意外险特别扩展条款-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "YWZYJTMC" && e.amount > 0) {
            arrperRiskInfo.push(
              "22-意外住院津贴每次事故-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "WGF" && e.amount > 0) {
            arrperRiskInfo.push("33-误工费-" + e.amount + "-" + e.premiumAmt);
          }
          if (e.riskCode == "YCXSCJY" && e.amount > 0) {
            arrperRiskInfo.push(
              "66-一次性伤残就业补助金-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "SHHLF" && e.amount > 0) {
            arrperRiskInfo.push("77-生活护理费-" + e.amount + "-" + e.premiumAmt);
          }
          if (e.riskCode == "GSDCGPF" && e.amount > 0) {
            arrperRiskInfo.push(
              "100-工伤定残高赔付标准-" + e.amount + "-" + e.premiumAmt
            );
          }
        });
        return arrperRiskInfo.join("#");
      },
      filter(inputValue, path) {
        return path.some((option) => {
          return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        });
      },
      //处理时间的
      effectiveDateChange(date1, date) {
        this.applicantInfo.effectiveDate = date;
      },
      //开始时间
      disabledDate(current) {
        return (current && current < moment()) || (current && current > moment().add(1, "months"));
      },
      // 计算总保费
      calTotalPremium() {
        let totalPremium = 0
        this.salInsuredList.forEach(element => {
          totalPremium += (element.premium - 0)
        })
        totalPremium = totalPremium.toFixed(2)
        if (this.form.getFieldValue("premiumCalType") == 0) { //基础保费
          this.applicantInfo.totalPremium = totalPremium
        }
        this.addTotalPrices = totalPremium
        this.form.setFieldsValue({
          addTotalPrices: totalPremium
        })
      },
      //修改
      EduitSelect(data) {
        this.salInsuredList.forEach((e, i) => {
          if (i == data.eduitIndex) {
            this.salInsuredList[i] = data;
          }
        });
      },
      //粘贴
      addSelectpre(data) {
        if (Array.isArray(data)) {
          this.salInsuredList.push(...data);
        } else {
          this.salInsuredList.push(data);
        }
        let cesiData = this.$lodash.cloneDeep(this.salInsuredList);
        this.salInsuredList = this.unique(this.salInsuredList, "idNumber");
        if (cesiData.length != this.salInsuredList.length) {
          this.$message.warning("受保人有重复，已做删除");
        }
      },
      //批量删除
      delSelectpre(data) {
        this.salInsuredList = data;
        let cesiData = JSON.parse(JSON.stringify(this.salInsuredList));
        this.salInsuredList = this.unique(this.salInsuredList, "idNumber");
        if (cesiData.length != this.salInsuredList.length) {
          this.$message.warning("受保人有重复，已做删除");
        }
      },
      //提交的去重
      unique(arr, attribute) {
        var new_arr = [];
        var json_arr = [];
        for (var i = 0; i < arr.length; i++) {
          if (new_arr.indexOf(arr[i][attribute]) == -1) {
            //  -1代表没有找到
            new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
            json_arr.push(arr[i]);
          }
        }
        return json_arr;
      },
      salInsuredListR(data) {
        data.forEach((e) => {
          if (e["gender"] == '男' || e["gender"] == 'M') {
            e["gender"] = "M";
          } else {
            e["gender"] = "F";
          }
          e.occulevel = e.occulevel == '特殊职业' ? 'S' : e.occulevel
          e.salInsuredExt = {
            planCode: e.workUnit
          }
        });
        return data;
      },
      //拼接gztypestr字段
      gztypestrPin() {
        var a = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        };
        delete this.CScontent["perRiskInfo"];
        for (const key in this.CScontent) {
          a[key] = this.CScontent[key];
        }
        let baofei = Object.values(a).join(";"); //总保费
        let b = [];
        this.salInsuredList.forEach((e) => {
          b.push(e.occulevel.toString().slice(0, 1));
        });
        this.maxType = Math.max(...b);
        var arr = [
          2,
          12,
          this.maxType,
          0, //费率
          this.industrycodeTEXT || "",
          this.applicantInfo.industrycode[3] || "",
          0,
          this.salInsuredList.length || 0,
          baofei,
          this.applicantInfo.companytype || "1",
        ];
        console.log(arr, "拼接的字符串");
        return arr.join(";");
      },
      //处理险种信息
      filterPlanList(list) {
        let arr = []
        list.forEach(element => {
          if (element.riskInfos) {
            element.riskInfos.forEach(elements => {
              arr.push({ ...elements, planCode: element.planName })
            })
          }
        })
        return arr
      },

      checkLength(value, param) {
        if ((param == "applicantInfo.name")) {
          if (value.indexOf("天津") != -1) {
            this.$message.error("本产品暂不支持天津地区投保！");
            this.form.setFieldsValue({
              applicantInfo: { name: "" },
            });
            return
          }
          this.queryCompanyCodeByName()
        }
        if ((param == "applicantInfo.detailaddress")) {
          var reg = RegExp(/小区|楼|村|巷|胡同|里弄|号|大厦|栋|幢|室|单元|门|组|房|座|层|排/);
          if (!reg.test(value) && value.length < 8) {
            this.$message.error("投保单位您输入的详细地址必须包含以下关键字：小区、楼、村、巷、胡同、里弄、号、大厦、栋、幢、室、单元、门、组、房、座、层、排；或者不少于8个字；请重新输入！");
            this.form.setFieldsValue({
              applicantInfo: { detailaddress: "" },
            });
          }
        }
      },
      filterPlaninfos(list) { //处理计划
        let arr = this.$lodash.cloneDeep(list)
        arr.forEach(element => {
          if (element.riskInfos) {
            delete element.riskInfos
          }
        })
        return JSON.stringify(arr)
      },
      //最后的提交
      handleSubmit() {
        this.form.validateFields((err, values) => {
          if (!err) {
            let base = this.applicantInfo;
            let gztypestrPin = this.gztypestrPin();
            if (!gztypestrPin) {
              this.$message.warning("请先进行试算！");
              return;
            }
            if (this.salInsuredList.length < 5) {
              this.$message.warning(
                "投保人须为团体，每张保单不少于5人投保。"
              );
              return;
            }
            let data = {
              salInsuredList: this.salInsuredListR(this.salInsuredList), //表格的数据
              salPolicy: {
                //保单信息
                planCode: this.plan, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                id: this.policyId,
                effectiveDate: moment(values.baodanData.startdata).format(
                  "YYYY-MM-DD"
                ), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format(
                  "YYYY-MM-DD"
                ), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付类型”
                bracket: 12,
                groupSize: this.salInsuredList.legnth || 0, //投保人数
                transactionTotalPremium: base.totalPremium,
                totalPremium: values.addTotalPrices || base.totalPremium, //totalPremium  总保费
                coverageamount: "", //totalSumInsured  总保额                remark: values.applicantInfo.remark, //备注
                remark: values.applicantInfo.remark,
                ordertraceno: "", //"凭证支付时的凭证号",
                discountfactor: values.premiumCalType
              },
              salPolicyExt: {
                isworkheightinvolved: this.planList[0].SFSGa, //是否高空作业
                occEmpVersion: this.fileCodeContent.id,
                occuRiskPremium: this.RiskInfos.salPolicyExt.occuRiskPremium,
              },
              salPolicyHolder: {
                //投保人信息
                planinfos: this.filterPlaninfos(this.planList),//投保计划
                addfifty: this.RiskInfos.salPolicyHolder.addfifty, //测算类型
                type: "C", //固定值
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                address: this.applicantInfo.address, //省市区中文
                detailaddress: values.applicantInfo.detailaddress, //详细地址
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                contactsphone: values.applicantInfo.contactsphone, //联系人电话
                telephone: values.applicantInfo.contactsphone, //联系人电话
                email: values.applicantInfo.email, //联系人邮箱
                vehicleown: this.applicantInfo.vehicleown, // 投保人行业名称
                engineno: this.applicantInfo.engineno, // 企业性质名称
                industrycode: values.applicantInfo.industrycode, //行业类型
                industryname: this.filterIndustryname(values.applicantInfo.industrycode),//企业类型名称
                province: values.applicantInfo.pacCode[0], //省
                city: values.applicantInfo.pacCode[1], //市
                district: values.applicantInfo.pacCode[2], //区
                gztypestr: '',
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                mobilestringcode: this.mobilestringcode, //每一类添加的保费
              },
              riskInfos: this.filterPlanList(this.planList),
            };
            this.postPolicyData = data;
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            this.$store.commit("setproductCode", this.productCode);
            this.submitLoad1 = true;
            this.axiosPolicy(); // 保存订单是 直接保存
          } else {
            this.$message.error("请填写完整提交的数据");
          }
        });
      },
      axiosPolicy() {
        //提交保单
        this.$api
          .addPAPolicy(this.postPolicyData)
          .then((res) => {
            if (res.data.returnCode == "00") {
              this.showPaySure = false;
              this.$message.success("保存成功！");
              this.policyId = res.data.content;
              this.$router.push({
                name: "fxty",
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  planCode: this.$route.query.planCode,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                },
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.submitLoad1 = false;
          });
      },
      paySure() {
        //支付确认
        this.showPaySure = false;
        this.submitLoad1 = false;
        this.submitLoad2 = false;
        this.policyId = this.$route.query.policyId;
        this.$payModal({
          show: true,
          type: "fxty", //产品类型
          policyId: this.policyId, //产品id
          creator: this.creator, //用户id
          payMethod: this.applicantInfo.payMethod, //支付方式
          totalPremium: this.applicantInfo.totalPremium, //支付总金额
          name: this.applicantInfo.name,
        });
      },
      filterIndustryname(val) { //return 行业类型名称
        return this.industryList.filter(item => item.value == val)[0].text
      },
      handleChange(value, type, label) {
        if (type == "pacCode") {
          this.applicantInfo[type] = label;
          if (label) {
            this.address =
              label.length > 2
                ? label[0].text + label[1].text + label[2].text
                : "";
          }
          sessionStorage.setItem("pacCode", value[2]);
        } else if (type == 'industrycode') {
          this.applicantInfo.vehicleown = label.componentOptions.children[0].text || ''
        } else {
          this.applicantInfo[type] = value;
        }
        if(type == 'idType') {
          this.queryCompanyCodeByName()
        }
      },
      queryCompanyCodeByName() {
        if(!this.applicantInfo.idType) {
          return
        }
        let type = this.applicantInfo.idType == '1' ? 2 : 1
        this.blurCompanyName(type)
      },
      addPremiumBlur(val) {
        this.$bus.$emit('addPremiumBlur', val.target.value)
      },
      limitDecimalsP(value) {
        let reg = /^(-)*(\d+)\.(\d\d).*$/;
        return value.replace(/￥\s?|(,*)/g, '').replace(reg, '$1$2.$3');
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$bus.$on("onRiskInfos", (data) => {
        console.log(data)
        this.planList = data
      })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() {
      this.$bus.$off("onRiskInfos");
      this.$bus.$off("CScontent");
    }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style scoped>
  .avatar-uploader>>>.ant-upload {
    width: 128px;
    height: 128px;
  }

  .avatar-uploader>>>.ant-upload img {
    width: 100%;
    height: 100%;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn_color {
    margin: 0 20px;
  }
</style>